/* eslint-disable */
import { Box, Button, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import { UserPlus } from "tabler-icons-react";
import HolidayTable from "./component/table";
import AddHolidayModal from "./component/addHolidays";
import { useGetUser } from "api/users/getUser";
import { PermissionButton } from "api/permission/buttonpermission";

export default function Holiday() {
  const [opened, setOpened] = useState(false);
  const { data: user } = useGetUser();

  return (
    <Box>
      <Group position="apart" mb="md">
        <Title order={3} sx={{ fontSize: "18px" }}>
          Holidays
        </Title>
        <Group>
          <PermissionButton
            permission="holiday_managment.create"
            // leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add Holiday
          </PermissionButton>
        </Group>
      </Group>

      <HolidayTable />
      <AddHolidayModal opened={opened} onClose={() => setOpened(false)} />
    </Box>
  );
}
